"use client"

import { useEffect } from "react"
import { ErrorBoundaryFallback, ErrorBoundaryFallbackProps } from "src/components/error/ErrorBoundaryFallback"
import { MinimalLayout } from "src/components/layout/MinimalLayout"
import { fontClassName } from "src/styles/fonts"
import "src/styles/global.css"

export default function GlobalError(props: ErrorBoundaryFallbackProps) {
  useEffect(() => {
    console.error(props.error)
  }, [props.error])

  return (
    <html lang="de">
      <body className={fontClassName}>
        <MinimalLayout>
          <ErrorBoundaryFallback {...props} />
        </MinimalLayout>
      </body>
    </html>
  )
}
